/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"
import googleMapConfig from "@/../googleMapConfig.js"

export default {
    addItem({ commit }, item) {
        return new Promise((resolve, reject) => {
            axios.post("/api/data-list/products/", { item: item })
                .then((response) => {
                    commit('ADD_ITEM', Object.assign(item, { id: response.data.id }))
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },
    fetch({ commit }, filters) {
        let queryString = ''
        if (filters) {
            queryString = '?' + Object.keys(filters).map(key => key + '=' + filters[key]).join('&');
        }

        commit('FETCH_TRANSACTIONS')
        return new Promise((resolve, reject) => {
            axios.get("/api/transactions/list" + queryString)
                .then((response) => {
                    commit('SET_TRANSACTIONS', response.data)
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },
    get({ commit }, transactionId) {
        commit('GET_TRANSACTION')
        return new Promise((resolve, reject) => {
            axios.get("/api/transactions/get/" + transactionId)
                .then((response) => {
                    commit('SET_TRANSACTION', response.data)
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },
    searchData({ commit }) {
        commit('FETCH_SEARCH_DATA')
        return new Promise((resolve, reject) => {
            axios.get("/api/transactions/search-data")
                .then((response) => {
                    commit('SET_SEARCH_DATA', response.data)
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },
    getCoord({ commit }, address) {
        return new Promise((resolve, reject) => {
            axios.post('/api/transactions/getCoord', { address: encodeURIComponent(address) })
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },
    getCity({ commit }, zipCode) {
        return new Promise((resolve, reject) => {
            axios.post('/api/transactions/getCity', { zipcCde: encodeURIComponent(zipCode) })
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },
    // fetchEventLabels({ commit }) {
    //   return new Promise((resolve, reject) => {
    //     axios.get("/api/apps/calendar/labels")
    //       .then((response) => {
    //         commit('SET_LABELS', response.data)
    //         resolve(response)
    //       })
    //       .catch((error) => { reject(error) })
    //   })
    // },
    save({ commit }, item) {
        return new Promise((resolve, reject) => {
            axios.post('/api/transactions/create', item)
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },
    saveSub({ commit }, item) {
        return new Promise((resolve, reject) => {
            axios.post('/api/transactions/create/sub', item)
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },
    delete({ commit }, id) {
        return new Promise((resolve, reject) => {
            console.log(id);
            axios.delete('/api/transactions/delete/' + id)
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },
}